import { Component, OnInit } from '@angular/core';
import { OtCityService } from '../ot-city.service';
import { City } from 'src/app/domain/ot-event';

@Component({
  selector: 'app-ot-city-list',
  templateUrl: './ot-city-list.component.html',
  styleUrls: ['./ot-city-list.component.scss']
})
export class OtCityListComponent implements OnInit {

  public cityList: City[];

  constructor(private otCityService: OtCityService) { }

  ngOnInit() {
    this.otCityService.findCitiesWithOtEvents().then(cityList => {
      this.cityList = cityList;
    });
  }

}
